export const createSparkles = (x: number, y: number) => {
  if (typeof window === 'undefined') return;

  const container = document.createElement('div');
  container.style.position = 'fixed';
  container.style.left = `${x}px`;
  container.style.top = `${y}px`;
  container.style.pointerEvents = 'none';
  container.style.zIndex = '9999';
  document.body.appendChild(container);

  const colors = ['#6aa0d4', '#e8749f', '#f9d371', '#8be3c4', '#b19ffb'];
  const sparkleCount = 10;
  for (let i = 0; i < sparkleCount; i++) {
    const particle = document.createElement('div');
    const size = Math.random() * 10 + 6;
    const color = colors[Math.floor(Math.random() * colors.length)];

    particle.style.position = 'absolute';
    particle.style.width = `${size}px`;
    particle.style.height = `${size}px`;
    particle.style.backgroundColor = color;

    particle.style.clipPath =
      'polygon(50% 0%, 65% 35%, 100% 50%, 65% 65%, 50% 100%, 35% 65%, 0% 50%, 35% 35%)';
    particle.style.opacity = '1';
    particle.style.transform = 'scale(0) rotate(0deg)';

    const angle = Math.random() * Math.PI * 2;
    const distance = Math.random() * 80 + 50;
    const dx = Math.cos(angle) * distance;
    const dy = Math.sin(angle) * distance;

    particle.animate(
      [
        {
          transform: 'scale(0) translate(0, 0) rotate(0deg)',
          opacity: 1,
        },
        {
          transform: `scale(1.2) translate(${dx * 0.8}px, ${dy * 0.8}px) rotate(${Math.random() * 180}deg)`,
          opacity: 0.9,
        },
        {
          transform: `scale(0) translate(${dx}px, ${dy}px) rotate(${Math.random() * 360}deg)`,
          opacity: 0,
        },
      ],
      {
        duration: Math.random() * 500 + 700,
        easing: 'cubic-bezier(0.15, 1, 0.3, 1)',
        fill: 'forwards',
      }
    );

    container.appendChild(particle);
  }

  setTimeout(() => {
    container.remove();
  }, 1300);
};

export const createConfetti = () => {
  if (typeof window === 'undefined') return;

  const container = document.createElement('div');
  container.style.position = 'fixed';
  container.style.inset = '0';
  container.style.pointerEvents = 'none';
  container.style.zIndex = '99999';
  document.body.appendChild(container);

  const colors = ['#6aa0d4', '#e8749f', '#f9d371', '#8be3c4', '#b19ffb'];

  const confettiCount = 80;

  for (let i = 0; i < confettiCount; i++) {
    const particle = document.createElement('div');
    const width = Math.random() * 12 + 6;
    const height = Math.random() * 16 + 8;
    const color = colors[Math.floor(Math.random() * colors.length)];

    particle.style.position = 'absolute';
    particle.style.left = `${Math.random() * 100}vw`;
    particle.style.top = `-20px`;
    particle.style.width = `${width}px`;
    particle.style.height = `${height}px`;
    particle.style.backgroundColor = color;
    particle.style.borderRadius = Math.random() > 0.5 ? '50%' : '3px';
    particle.style.opacity = '1';

    const drift = Math.random() * 200 - 100;
    const fallDuration = Math.random() * 1500 + 2500;

    particle.animate(
      [
        {
          transform: 'translateY(0) rotate(0deg) rotateX(0deg)',
          opacity: 1,
        },
        {
          transform: `translateY(50vh) translateX(${drift * 0.5}px) rotate(${Math.random() * 360}deg) rotateX(${Math.random() * 360}deg)`,
          opacity: 0.9,
        },
        {
          transform: `translateY(105vh) translateX(${drift}px) rotate(${Math.random() * 720}deg) rotateX(${Math.random() * 720}deg)`,
          opacity: 0,
        },
      ],
      {
        duration: fallDuration,
        easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
        fill: 'forwards',
      }
    );

    container.appendChild(particle);
  }

  setTimeout(() => {
    container.remove();
  }, 4500);
};
